import React from "react";
import { Text, Platform, StyleSheet } from "react-native";

import AppTheme from "../../AppTheme";
import { pluralize } from "../../../../helpers/utils";
import { MoodColors } from "../../common/mood/MoodsHelper";

export default function AccountSubTitle({
  name,
  count,
  label = "active calendar",
}) {
  return (
    <Text style={[styles.caption, count > 0 ? {} : styles.inactive]}>
      {name ? `${name} • ` : ""}
      {pluralize(label, count)}
    </Text>
  );
}

const styles = StyleSheet.create({
  caption: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  inactive: {
    color: MoodColors.VeryBad,
  },
});
